import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { deleteReport, getReports, saveReport, getReport } from "../api/InsightApi";

const api = {
  [ActionTypes.getReports]: (workspaceId) => getReports(workspaceId),
  // Fetch one report by id (detail-first flow)
  [ActionTypes.getReport]: (workspaceId, reportId) => getReport(workspaceId, reportId),
  [ActionTypes.deleteReport]: async (workspaceId, reportId) => {
    await deleteReport(workspaceId, reportId);
    return { reportId, workspaceId };
  },
  [ActionTypes.saveReport]: (workspaceId, reportData) => saveReport(workspaceId, reportData),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
